// Claude: barrel — re-exports all admin API methods as single AdminAPI object 14-04-2026
// Sub-files: adminEventAPI.js | adminSellerAPI.js | adminBuyerAPI.js | adminIndustryAPI.js | adminPlatformAPI.js
import { AdminEventAPI } from "./adminEventAPI.js";
import { AdminSellerAPI } from "./adminSellerAPI.js";
import { AdminBuyerAPI } from "./adminBuyerAPI.js";
import { AdminIndustryAPI } from "./adminIndustryAPI.js";
import { AdminPlatformAPI } from "./adminPlatformAPI.js";

export const AdminAPI = {
  ...AdminEventAPI,
  ...AdminSellerAPI,
  ...AdminBuyerAPI,
  ...AdminIndustryAPI,
  ...AdminPlatformAPI,
};
